import tinValidator from 'german-tax-id-validator';
import * as Output from '../../Text';

export const fiscalNumber = (v) => {
  if (!v) {
    return undefined;
  }

  if (!tinValidator.validate(v)) {
    return Output.resolve(
      'generic.errors.M002_invalidCharacters',
    );
  }

  return undefined;
};
